import React, { useState } from 'react'
import { useTranslate } from 'react-admin'
import { Box, Typography, Dialog, DialogContent, Button, DialogActions } from '@mui/material'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export const TrainSegmentCondition = ({ open, handleClose, trainInformation }) => {
  if (trainInformation && 
      trainInformation?.conditions && 
      Array.isArray(trainInformation?.conditions) &&
      trainInformation?.conditions.length > 0 
    ){
    return (<TrainSegmentConditionModal open={open} handleClose={handleClose} data={trainInformation?.conditions}/>)
  }
  else if (
    trainInformation &&
    trainInformation.products &&
    Array.isArray(trainInformation?.products) &&
    trainInformation?.products.length > 0
  ) {
    return (<TrainSegmentConditionModal open={open} handleClose={handleClose} data={trainInformation.products[0]?.conditions}/>)
  }
}

const TrainSegmentConditionModal = ({open, handleClose, data, dataName}) => {
  const translate = useTranslate()
  const [conditionPage, setConditionPage] = useState(0)
  const isDiabledNext = () =>{
    return (conditionPage === (data.length - 1) || data.length === 0)
  }
  const isDisabledPrevious = () =>{
    return conditionPage === 0
  }
  const nextPage = () =>{
    if(!isDiabledNext()){
      setConditionPage(conditionPage+1)
    }
  }
  const previousPage = () =>{
    if(!isDisabledPrevious()){
      setConditionPage(conditionPage-1)
    }
  }
  return (
    <Dialog open={open} maxWidth='lg' fullWidth={true}>
      <DialogContent>
        <Box style={{ border: '4px solid #F9F9FD', borderRadius: '10px', padding: 10 }}>
          <Typography variant='h6' component='div' textAlign={'center'}>
            {translate('ra.title.condition')}
          </Typography>
          {Array.isArray(data) ?
            <div style={{
              display:'flex', 
              alignItems:'center',
              flexDirection:'column'
            }}>
              <div
                dangerouslySetInnerHTML={{ __html: data[conditionPage]?.large_description }}
              />
              <div style={{display:'flex', flexDirection:'row', marginTop:'15px'}}>
                <KeyboardArrowLeftIcon onClick={previousPage} style={{cursor:!isDisabledPrevious() ? 'pointer':'default'}} color={isDisabledPrevious() ? 'disabled' :'info'}/>
                <KeyboardArrowRightIcon onClick={nextPage} style={{cursor:!isDiabledNext() ? 'pointer':'default'}} color={isDiabledNext() ? 'disabled' : 'info'}/>
              </div>
            </div> 
            :
            <div
              dangerouslySetInnerHTML={{ __html: data  }}
            />
          }
        </Box>
        <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
          <Button onClick={handleClose} variant='outlined' color='error'>
            {translate('ra.action.close')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
} 